import { render, staticRenderFns } from "./_shopping_modal.vue?vue&type=template&id=577a19e2&"
import script from "./_shopping_modal.vue?vue&type=script&lang=js&"
export * from "./_shopping_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports